import { useEffect, useState } from "react";
import { useAuth, API } from "@/App";
import axios from "axios";
import ContentManager from "@/components/ContentManager";

/**
 * Images: the content library, as a gallery.
 *
 * Round 3, item 4.3. Images had been removed on the reasoning that /creatives is a
 * builder rather than a library, which was right about the route and wrong to leave no
 * gallery. This is the looking-at-what-you-have half; making things stays in Creative
 * builder.
 *
 * Deliberately thin. It renders ContentManager in gallery mode rather than duplicating
 * the grid, so a change to how content is displayed cannot show two different things in
 * two places.
 */
export default function ContentGallery() {
  const { token } = useAuth();
  const [branding, setBranding] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/company-branding`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setBranding(r.data))
      .catch(() => setBranding(null));  // optional: the gallery renders without it
  }, [token]);

  return (
    <div className="space-y-6 animate-fade-in max-w-[1400px]">
      <ContentManager brandColors={branding?.colors || []} galleryOnly />
    </div>
  );
}
